import { createStyles } from 'antd-style';

import { flexCenter } from '../styles/mixins';

export const useNonLoggedFooterStyles = createStyles(({ token }) => ({
  nonLoggedFooterLinksAbove: {
    color: token.colorPrimary,
    fontWeight: 'bold',
  },
  loggedFooterLinks: {
    ...flexCenter(),
    marginBottom: token.marginXXS,

    '.DropdownMenu-Label, .Popup-Label': {
      '.fa-caret-down, .fa-caret-up': {
        fontSize: token.fontSize,
      },
    },
  },
}));
